import React from 'react';
import {Image,} from 'react-bootstrap';
import Logo from './../assets/img/Logo.jpg';
import Style from './Header.module.css';

const Header = () => {
    return ( 
        <header className={Style.header_row}>
                    <div className={Style.header_row_content}>
                        <div className= {Style.header_row_icon}>
                        <Image className={Style.icon} src={Logo}></Image>
                        </div>
                    </div>
        </header>
     );
}
 
export default Header;
